export default {
  image: 'A4_6.png',
  pdf: '220815_WA-MIWO_004_A4_6_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-004',
    technicalValues: {
      soundReductionIndex: {
        output: '50,2',
        value: 50.2
      },
      heatTransferCoefficient: {
        output: '0,23',
        value: 0.23
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 4',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Steinwolleplatte 2/B/H4 W5',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'mst-60'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '≥ 60/100',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-100'
        },
        {
          output: '100 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-100'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: 'keine',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: null
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '194',
        value: 194
      }
    }
  }
}
